	export enum SalesOrderTeleHealthTypeFilterEnum {
		Sales = 1,
		Revenues = 2,
		Fulfilled = 3
	}
